import { Form } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import { includes } from 'lodash';
import React from 'react';
import type { Composant } from '@/src/interfaces/composant';
import { getAssietteEligible } from '@/src/utils/subvention';

interface ProjetComposantInputProps {
	onChange: any;
	composants: Composant[];
	selectedComposants: Partial<Composant>[];
	identifiant: number;
	plafondEligible: number;
	realisationHT: number;
	tauxAide: number;
}

const ProjetComposantInput = ({
	composants = null,
	onChange = null,
	selectedComposants = null,
	identifiant = null,
	plafondEligible = 0,
	realisationHT = 0,
	tauxAide = 0,
}: ProjetComposantInputProps) => {
	const mapComposantToDropdown = () =>
		composants?.map((composant) => ({
			key: composant.identifiant,
			value: composant.identifiant,
			text: composant.libelle,
			dataTestId: composant.libelle,
		}));

	const getComposantsByValues = React.useCallback(
		(values) => {
			const elements = [];
			composants?.forEach((composant: any) => {
				if (includes(values, composant.identifiant)) {
					elements.push(composant);
				}
			});

			return elements;
		},
		[composants],
	);

	const handleChange = React.useCallback(
		(_e, { value }) => {
			const updatedComposants = getComposantsByValues(value);
			const assietteEligible = getAssietteEligible(
				plafondEligible,
				updatedComposants,
				realisationHT,
			);
			onChange({
				identifiant,
				composants: updatedComposants,
				assietteEligible,
				montantEnvisage: (assietteEligible * tauxAide) / 100,
			});
		},
		[
			getComposantsByValues,
			identifiant,
			onChange,
			realisationHT,
			plafondEligible,
			tauxAide,
		],
	);

	return (
		<Form.Field
			control={Combobox}
			data-testid="composantsSubvention"
			// @ts-expect-error
			fluid
			label="Composante(s) du projet associée(s)"
			multiple
			noResultsMessage="Aucun composant trouvé"
			onChange={handleChange}
			options={mapComposantToDropdown()}
			placeholder="Composants"
			renderLabel={(item) => ({
				content: item.text,
				'data-testid': item.dataTestId,
			})}
			search
			selection
			value={selectedComposants?.map((composant) => composant?.identifiant)}
		/>
	);
};

export default ProjetComposantInput;
